import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const product_passport_visit_log = apiUrl + "/product_passport_visit_log";
const routes = {
  label: "Product Passport Visit Log",
  root: product_passport_visit_log,
  get_all_mine_company: product_passport_visit_log + "/get_all_mine_company",
  get: product_passport_visit_log + "/get",
  get_by_entity_id: product_passport_visit_log + "/get_by_entity_id",
  new: product_passport_visit_log + "/new",
};
export const ProductPassportVisitLog = {
  label: routes.label,
  getAllMineCompany: () => postWithToken(routes.get_all_mine_company),
  get: (product_id) => postWithToken(routes.get, { product_id }),
  get_by_entity_id: (id, entityType = "product") => postWithToken(routes.get_by_entity_id, { id, entity_type: entityType }),
  new: (passport) => postWithToken(routes.new, passport),
};
